<template>
  <div class="files-list" data-testid="files-list">
    <ExpansionPanels
      v-if="hasFiles"
      :items="idEnriched"
      :multiple="false"
      :activePanels="activePanel"
      :useDefaultHeader="false" >

      <template slot="title" slot-scope="titleSlot">
        <FileListItem
          :fileTitle="titleSlot.item.name"
          :fileUid="titleSlot.item.uid"
          :fileSize="titleSlot.item.file.size"
          :actions="selectActions(titleSlot)"
          :isSignatureRequired="titleSlot.item.signatureRequired"
          :errorMessage="titleSlot.item.errorMessage"
          @file-action-clicked="onFileActionClicked(titleSlot.item, ...arguments)" />
      </template>

      <template slot="content" slot-scope="contentSlot">
        <UploadFileDetailsForm
          :fileDescription="contentSlot.item.description"
          :fileUid="contentSlot.item.uid"
          :fileTitle="contentSlot.item.name"
          @close-dialog="handleCloseDialog"
          @edit-item="(fileUid, newItem) => $emit('edit-item', fileUid, newItem)" />
      </template>

    </ExpansionPanels>

    <div v-else class="empty-state" data-testid="empty-state">
      {{ $t('common.actions.types.document.empty_state') }}
    </div>

  </div>
</template>


<script>

import FileListItem from "@/modules/common/components/FileListItem/FileListItem";
import UploadFileDetailsForm from "@/modules/common/components/UploadFileDetailsForm/UploadFileDetailsForm";
import ExpansionPanels from "@/modules/common/components/ExpansionPanels";

export default {
  name: 'FilesList',
  components: {
    FileListItem,
    UploadFileDetailsForm,
    ExpansionPanels
  },
  data() {
    return {
      defaultActions: [
        {
          type: 'Edit',
          icon: 'icon-pencil-s',
          color: 'grey'
        },
        {
          type: 'Delete',
          icon: 'icon-16trash',
          color: 'grey'
        }
      ],
      activeActions: [],
      errorActions: [
        {
          type: 'Delete',
          icon: 'icon-16trash',
          color: 'grey'
        }
      ]
    }
  },
  props:{
    filesList: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    hasFiles() {
      return this.filesList.length
    },
    idEnriched() {
      return this.filesList.map(item => Object.assign(item, {id: item.uid}))
    },
    activePanel() {
      return [this.idEnriched[0].id]
    }
  },
  methods: {
    selectActions(item) {
      let actions = this.defaultActions;
      if (item.panels === item.idx) {
        actions = this.activeActions;
      } else if (item.item.errorMessage) {
        actions = this.errorActions;
      }

      return actions;
    },
    handleCloseDialog() {
      this.$emit('close-dialog');
    },

    onFileActionClicked(item, action, fileUid) {
      this.$emit('file-action-clicked', item, action, fileUid);
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.files-list {

  .empty-state {
    font-size: 13px;
    font-weight: 400;
    color: $grey-color-20;
    padding-block: 23px;
    text-align: center;
  }

  .v-expansion-panel {
    padding: 0;

    &-header {
      padding: 0;

      &__icon {
        display: none;
      }
    }
  }
}

</style>
